module.exports = __webpack_public_path__ + "images/RBL_cares_logoc68e405dcfca15de015ede913bfd478e.svg";